function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * @typedef {Object} APIProcessorResponseHTTPShape
 * @property {string} message
 * @property {int} code
 */

/**
 * @typedef {Object} APIProcessorResponseShape
 * @property {APIProcessorResponseHTTPShape} http
 * @property {Array<string>} error
 * @property {Array<string>} success
 */

/**
 * @typedef {Object} OptionsShape
 * @property {string} base_url
 */

var textEncoder = new TextEncoder();
var textDecoder = new TextDecoder();
var bytesToBase64 = function bytesToBase64(bytes) {
  var binary = "";
  bytes.forEach(function (_byte) {
    binary += String.fromCharCode(_byte);
  });
  return btoa(binary);
};
var base64ToBytes = function base64ToBytes(base64) {
  var binary = atob(base64);
  var bytes = new Uint8Array(binary.length);
  for (var i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};
var resolveAESSecret = function resolveAESSecret() {
  return process.env.PAYLOAD_AES_SECRET || process.env.PAYLOAD_AES_KEY || "";
};
var resolveBackendPublicKey = function resolveBackendPublicKey() {
  return process.env.__PAYLOAD_RSA_PUBLIC_KEY || process.env.PAYLOAD_PUBLIC_KEY || "";
};
var resolveFrontendPrivateKey = function resolveFrontendPrivateKey() {
  return process.env.__RESPONSE_PAYLOAD_RSA_SECRET || process.env.PAYLOAD_RSA_PRIVATE_KEY || process.env.PAYLOAD_PRIVATE_KEY || "";
};
var pemToArrayBuffer = function pemToArrayBuffer(pem) {
  var normalizedPem = pem.replace(/\\n/g, "\n");
  var pemBody = normalizedPem.replace(/-----BEGIN PUBLIC KEY-----/g, "").replace(/-----END PUBLIC KEY-----/g, "").replace(/\s+/g, "");
  return base64ToBytes(pemBody).buffer;
};
var privatePemToArrayBuffer = function privatePemToArrayBuffer(pem) {
  var normalizedPem = pem.replace(/\\n/g, "\n");
  var pemBody = normalizedPem.replace(/-----BEGIN PRIVATE KEY-----/g, "").replace(/-----END PRIVATE KEY-----/g, "").replace(/\s+/g, "");
  return base64ToBytes(pemBody).buffer;
};
var importBackendPublicKey = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var publicKey;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          publicKey = resolveBackendPublicKey();
          if (publicKey) {
            _context.n = 1;
            break;
          }
          throw new Error("Missing PAYLOAD_RSA_PUBLIC_KEY (or PAYLOAD_PUBLIC_KEY) environment variable.");
        case 1:
          return _context.a(2, crypto.subtle.importKey("spki", pemToArrayBuffer(publicKey), {
            name: "RSA-OAEP",
            hash: "SHA-1"
          }, false, ["encrypt"]));
      }
    }, _callee);
  }));
  return function importBackendPublicKey() {
    return _ref.apply(this, arguments);
  };
}();
var importAESKey = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var secret, digest;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          secret = resolveAESSecret();
          if (secret) {
            _context2.n = 1;
            break;
          }
          throw new Error("Missing PAYLOAD_AES_SECRET (or PAYLOAD_AES_KEY) environment variable.");
        case 1:
          _context2.n = 2;
          return crypto.subtle.digest("SHA-256", textEncoder.encode(secret));
        case 2:
          digest = _context2.v;
          return _context2.a(2, crypto.subtle.importKey("raw", digest, {
            name: "AES-CBC",
            length: 256
          }, false, ["encrypt", "decrypt"]));
      }
    }, _callee2);
  }));
  return function importAESKey() {
    return _ref2.apply(this, arguments);
  };
}();
var importFrontendPrivateKey = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
    var privateKey;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          privateKey = resolveFrontendPrivateKey();
          if (privateKey) {
            _context3.n = 1;
            break;
          }
          throw new Error("Missing __RESPONSE_PAYLOAD_RSA_SECRET (or PAYLOAD_RSA_PRIVATE_KEY / PAYLOAD_PRIVATE_KEY) environment variable.");
        case 1:
          return _context3.a(2, crypto.subtle.importKey("pkcs8", privatePemToArrayBuffer(privateKey), {
            name: "RSA-OAEP",
            hash: "SHA-1"
          }, false, ["decrypt"]));
      }
    }, _callee3);
  }));
  return function importFrontendPrivateKey() {
    return _ref3.apply(this, arguments);
  };
}();
export var encryptPayloadAES = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(payload) {
    var backendPublicKey, symmetricKey, iv, plainText, encrypted, rawSymmetricKey, encryptedSymmetricKey;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return importBackendPublicKey();
        case 1:
          backendPublicKey = _context4.v;
          _context4.n = 2;
          return crypto.subtle.generateKey({
            name: "AES-GCM",
            length: 256
          }, true, ["encrypt", "decrypt"]);
        case 2:
          symmetricKey = _context4.v;
          iv = crypto.getRandomValues(new Uint8Array(12));
          plainText = typeof payload === "string" ? payload : JSON.stringify(payload);
          _context4.n = 3;
          return crypto.subtle.encrypt({
            name: "AES-GCM",
            iv: iv
          }, symmetricKey, textEncoder.encode(plainText));
        case 3:
          encrypted = _context4.v;
          _context4.n = 4;
          return crypto.subtle.exportKey("raw", symmetricKey);
        case 4:
          rawSymmetricKey = _context4.v;
          _context4.n = 5;
          return crypto.subtle.encrypt({
            name: "RSA-OAEP"
          }, backendPublicKey, rawSymmetricKey);
        case 5:
          encryptedSymmetricKey = _context4.v;
          return _context4.a(2, {
            ciphertext: bytesToBase64(new Uint8Array(encrypted)),
            iv: bytesToBase64(iv),
            encrypted_key: bytesToBase64(new Uint8Array(encryptedSymmetricKey)),
            key_alg: "RSA-OAEP",
            enc: "A256GCM"
          });
      }
    }, _callee4);
  }));
  return function encryptPayloadAES(_x) {
    return _ref4.apply(this, arguments);
  };
}();
export var decryptPayloadAES = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(payload) {
    var key, iv, decrypted, plainText, _t;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          if (!(!(payload !== null && payload !== void 0 && payload.ciphertext) || !(payload !== null && payload !== void 0 && payload.iv))) {
            _context5.n = 1;
            break;
          }
          throw new Error("Invalid encrypted payload. Expected ciphertext and iv.");
        case 1:
          _context5.n = 2;
          return importAESKey();
        case 2:
          key = _context5.v;
          iv = base64ToBytes(payload.iv);
          _context5.n = 3;
          return crypto.subtle.decrypt({
            name: "AES-CBC",
            iv: iv
          }, key, base64ToBytes(payload.ciphertext));
        case 3:
          decrypted = _context5.v;
          plainText = textDecoder.decode(decrypted);
          _context5.p = 4;
          return _context5.a(2, JSON.parse(plainText));
        case 5:
          _context5.p = 5;
          _t = _context5.v;
          return _context5.a(2, plainText);
      }
    }, _callee5, null, [[4, 5]]);
  }));
  return function decryptPayloadAES(_x2) {
    return _ref5.apply(this, arguments);
  };
}();
export var decryptPayloadHybridRSA = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(payload) {
    var _payload$m$split, _payload$m$split2, keyCipher, iv, keyLenRaw, keyLen, middle, cipherTextLength, leftEncryptedKey, cipherText, rightEncryptedKey, finalEncryptedKey, privateKey, decryptedKey, symmetricKey, decrypted, plainText, _t2;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.p = _context6.n) {
        case 0:
          if (payload !== null && payload !== void 0 && payload.m) {
            _context6.n = 1;
            break;
          }
          throw new Error("Invalid encrypted payload. Expected ciphertext, iv and encrypted_key.");
        case 1:
          // extract the parts
          _payload$m$split = payload.m.split("."), _payload$m$split2 = _slicedToArray(_payload$m$split, 3), keyCipher = _payload$m$split2[0], iv = _payload$m$split2[1], keyLenRaw = _payload$m$split2[2];
          keyLen = Number.parseInt(keyLenRaw, 10);
          if (!(!keyCipher || !iv || Number.isNaN(keyLen) || keyLen <= 0 || keyLen > keyCipher.length)) {
            _context6.n = 2;
            break;
          }
          throw new Error("Invalid encrypted payload format.");
        case 2:
          middle = Math.floor(keyLen / 2);
          cipherTextLength = keyCipher.length - keyLen;
          leftEncryptedKey = keyCipher.substring(0, middle);
          cipherText = keyCipher.substring(middle, middle + cipherTextLength);
          rightEncryptedKey = keyCipher.substring(middle + cipherTextLength);
          finalEncryptedKey = "".concat(leftEncryptedKey).concat(rightEncryptedKey);
          _context6.n = 3;
          return importFrontendPrivateKey();
        case 3:
          privateKey = _context6.v;
          _context6.n = 4;
          return crypto.subtle.decrypt({
            name: "RSA-OAEP"
          }, privateKey, base64ToBytes(finalEncryptedKey));
        case 4:
          decryptedKey = _context6.v;
          _context6.n = 5;
          return crypto.subtle.importKey("raw", decryptedKey, {
            name: "AES-GCM"
          }, false, ["decrypt"]);
        case 5:
          symmetricKey = _context6.v;
          _context6.n = 6;
          return crypto.subtle.decrypt({
            name: "AES-GCM",
            iv: base64ToBytes(iv)
          }, symmetricKey, base64ToBytes(cipherText));
        case 6:
          decrypted = _context6.v;
          plainText = textDecoder.decode(decrypted);
          _context6.p = 7;
          return _context6.a(2, JSON.parse(plainText));
        case 8:
          _context6.p = 8;
          _t2 = _context6.v;
          return _context6.a(2, plainText);
      }
    }, _callee6, null, [[7, 8]]);
  }));
  return function decryptPayloadHybridRSA(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var xhr = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(path, options, callback) {
    var _options$base_url;
    var response, headerObj, mustEncryptPayload, jwt, tokenKey, tokenRefreshKey, encryptionElements, encryptedKey, encryptedKeyLen, leftLen, leftEncryptedKey, rightEncryptedKey;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          response = null;
          headerObj = {};
          mustEncryptPayload = process.env.__PAYLOAD_IS_ENCRYPTED === 'true';
          if (process.env.IS_AUTH_BASED === "1") {
            jwt = localStorage.getItem(process.env.TOKEN_KEY);
            headerObj['Authorization'] = "Bearer ".concat(jwt);
          } else {
            tokenKey = process.env.TOKEN_KEY;
            tokenRefreshKey = process.env.TOKEN_REFRESH_KEY;
            headerObj['X-BROWSER-URL'] = document.location.pathname + "::" + document.location.search;
            if (tokenKey && tokenRefreshKey && (options.include_token_headers === void 0 || options.include_token_headers)) {
              headerObj['X-TOKEN-KEY'] = tokenKey;
              headerObj['X-TOKEN-REFRESH-KEY'] = tokenRefreshKey;
            }
          }
          if (_typeof(options.body) === 'object') {
            options.body = JSON.stringify(options.body);
          }
          if (!(options.body && mustEncryptPayload)) {
            _context8.n = 2;
            break;
          }
          _context8.n = 1;
          return encryptPayloadAES(options.body);
        case 1:
          encryptionElements = _context8.v;
          encryptedKey = encryptionElements.encrypted_key;
          encryptedKeyLen = encryptedKey.length;
          leftLen = Math.floor(encryptedKeyLen / 2);
          leftEncryptedKey = encryptedKey.substring(0, leftLen);
          rightEncryptedKey = encryptedKey.substring(leftLen, encryptedKeyLen);
          options.body = JSON.stringify({
            m: "".concat(leftEncryptedKey).concat(encryptionElements.ciphertext).concat(rightEncryptedKey, ".").concat(encryptionElements.iv, ".").concat(encryptedKeyLen)
          });
        case 2:
          _context8.n = 3;
          return fetch(((_options$base_url = options.base_url) !== null && _options$base_url !== void 0 ? _options$base_url : process.env.API) + path, _objectSpread(_objectSpread({
            credentials: 'include'
          }, options), {}, {
            headers: _objectSpread(_objectSpread({}, headerObj), options.headers)
          })).then(function (http_response) {
            return http_response.json();
          }).then(/*#__PURE__*/function () {
            var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(res) {
              return _regenerator().w(function (_context7) {
                while (1) switch (_context7.n) {
                  case 0:
                    if (!(mustEncryptPayload && res !== null && res !== void 0 && res.m)) {
                      _context7.n = 2;
                      break;
                    }
                    _context7.n = 1;
                    return decryptPayloadHybridRSA(res);
                  case 1:
                    return _context7.a(2, _context7.v);
                  case 2:
                    return _context7.a(2, res);
                }
              }, _callee7);
            }));
            return function (_x7) {
              return _ref8.apply(this, arguments);
            };
          }()).then(function (res) {
            if (res !== null && res !== void 0 && res.http) {
              if (res.http.code > 199 && res.http.code < 300) {
                response = res;
              } else {
                if (res.http.code === 401) {
                  response = {
                    error: ['Unauthorized']
                  };
                }
                if (res.http.code === 404) {
                  response = {
                    error: ['Not found']
                  };
                }
              }
            }
            response = res;
          })["catch"](function (e) {
            response = {
              error: ['Something went wrong', e.toString()]
            };
          })["finally"](function () {
            callback === null || callback === void 0 || callback(response);
          });
        case 3:
          return _context8.a(2);
      }
    }, _callee8);
  }));
  return function xhr(_x4, _x5, _x6) {
    return _ref7.apply(this, arguments);
  };
}();
export var __put = function __put(path, options, callback) {
  xhr(path, _objectSpread(_objectSpread({}, options), {
    method: 'PUT'
  }), callback);
};
export var _put = function _put(path, fragment, callback) {
  xhr(path, {
    body: _typeof(fragment) === 'object' ? JSON.stringify(fragment) : fragment,
    method: "PUT"
  }, callback);
};

/**
 * @param path
 * @param {OptionsShape=} options
 * @param callback
 * @private
 */
export var __get = function __get(path, options, callback) {
  xhr(path, _objectSpread(_objectSpread({}, options), {
    method: 'GET'
  }), callback);
};
export var _get = function _get(path, callback) {
  xhr(path, {
    method: 'GET'
  }, callback);
};
export var __delete = function __delete(path, options, callback) {
  xhr(path, _objectSpread(_objectSpread({}, options), {
    method: 'DELETE'
  }), callback);
};
export var _delete = function _delete(path, callback) {
  xhr(path, {
    method: "DELETE"
  }, callback);
};
export var __post = function __post(path, options, callback) {
  xhr(path, _objectSpread(_objectSpread({}, options), {
    method: 'POST'
  }), callback);
};
export var _post = function _post(path, fragment, callback) {
  xhr(path, {
    method: 'POST',
    body: _typeof(fragment) === 'object' ? JSON.stringify(fragment) : fragment
  }, callback);
};
export var _query = function _query(path, fragment, callback) {
  xhr(path, {
    method: 'QUERY',
    body: _typeof(fragment) === 'object' ? JSON.stringify(fragment) : fragment
  }, callback);
};
export var isHttpOK = function isHttpOK(response) {
  var _response$http;
  return (response === null || response === void 0 || (_response$http = response.http) === null || _response$http === void 0 ? void 0 : _response$http.code) === 200;
};
export var isHttpWithData = function isHttpWithData(response) {
  var _response$http2;
  return (response === null || response === void 0 || (_response$http2 = response.http) === null || _response$http2 === void 0 ? void 0 : _response$http2.code) === 200 && response.data ? response.data : undefined;
};
export var isUnauthorized = function isUnauthorized(response, __httpStatusCodeSetter) {
  var _response$http3, _response$http4;
  if ((response === null || response === void 0 || (_response$http3 = response.http) === null || _response$http3 === void 0 ? void 0 : _response$http3.code) === 401) {
    __httpStatusCodeSetter === null || __httpStatusCodeSetter === void 0 || __httpStatusCodeSetter(401);
  }
  return (response === null || response === void 0 || (_response$http4 = response.http) === null || _response$http4 === void 0 ? void 0 : _response$http4.code) === 401;
};
export var isNotOK = function isNotOK(response) {
  var _response$http5;
  return (response === null || response === void 0 || (_response$http5 = response.http) === null || _response$http5 === void 0 ? void 0 : _response$http5.code) !== 200;
};
export var evalFieldErrors = function evalFieldErrors(_ref9) {
  var formContext = _ref9.formContext,
    apiResponse = _ref9.apiResponse;
  if (apiResponse.field_errors) {}
};
export var httpIsOK = function httpIsOK(httpStatusCode) {
  if (httpStatusCode === void 0 || httpStatusCode === null) return true;
  return httpStatusCode >= 200 && httpStatusCode < 300;
};
export var dataToObjWithNotFound = function dataToObjWithNotFound(response, setter) {
  if (isHttpOK(response)) {
    var _isHttpWithData;
    setter((_isHttpWithData = isHttpWithData(response)) !== null && _isHttpWithData !== void 0 ? _isHttpWithData : {});
  } else {
    var _response$http6;
    if (((_response$http6 = response.http) === null || _response$http6 === void 0 ? void 0 : _response$http6.code) > 299) {
      setter("NOT_FOUND");
    }
  }
};
export var getQueryParam = function getQueryParam(param) {
  var _URLSearchParams;
  return (_URLSearchParams = new URLSearchParams(document.location.search)) === null || _URLSearchParams === void 0 ? void 0 : _URLSearchParams.get(param);
};